import { BrandItem, BrandItemLink } from './styles';
import React, { forwardRef } from 'react';
import withPointerUpHandling from 'common/hocs/with-pointer-up-handling';
import { SponsoredBrandItemProps } from './sponsored-brand-item';

interface BrandItemProps extends SponsoredBrandItemProps {}

export const BrandsItem = forwardRef<HTMLDivElement, BrandItemProps>((props, ref) => {
  const { brand, id } = props;

  return (
    <BrandItem ref={ref}>
      <BrandItemLink href={brand.targetUrl}>
        <picture>
          <img src={brand.pictureUrl} alt={`Brand ${id}`} />
        </picture>
      </BrandItemLink>
    </BrandItem>
  );
});

export const SponsoredBrandItemWithClickEvent = withPointerUpHandling(BrandsItem);
